import { Component, OnInit, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { AuthService } from 'src/app/services/auth.service';
import { PrintService } from 'src/app/services/print.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { SendUpdateAPIComponent } from '../../forms/send-update-api/send-update-api.component';
import { FrmManageMiscEventsComponent } from '../../forms/frm-manage-misc-events/frm-manage-misc-events.component';
import { WeekYearChangeEvent } from '../../shared/week-year-selector/week-year-selector.component';
import { CurrencyService } from '../../../services/currency.service';
import { LoggerService } from '../../../services/logger.service';

/**
 * Filter controls whose values must survive a week/year change.
 *
 * The form also carries display-only controls (package_costs,
 * transportation_costs) that are not filters and must not be sent as params.
 */
const MISC_REPORT_FILTER_FIELDS = [
  'field_package_code',
  'field_date_and_time_value_start',
  'field_date_and_time_value_end',
  'event_date_and_time_value_start',
  'event_date_and_time_value_end',
];

@Component({
  selector: 'app-ami-misc-report',
  templateUrl: './ami-misc-report.component.html',
  styleUrls: ['./ami-misc-report.component.css']
})
export class AmiMiscReportComponent extends ViewTableComponent implements OnInit {

  constructor(
    public override _refreshService: RefreshService,
    private _printService: PrintService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private currencyService: CurrencyService,
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  override displayedColumns: string[] = [
    'payment_id',
    'field_sale_date',
    'field_student',
    'field_instructor_percentages',
    'total_charges_due',
    'field_total_payments_made',
    'field_enrollment_package_name',
    'field_sps_code',
    // 'field_package_code',
  ];

  currentReport: string = 'miscReport';
  week: string;
  year: string;
  moment = moment; // Make moment available in the template

  miscServiceDeductions: any;
  totalPaymentsMadeMiscReport:number = 0;
  totalChargesDueMiscReport: number;
  totalTransportationCharges = 0;
  totalEventExpenses = 0;
  totalSubjectToPercentage = 0;
  additionalAmountDue = 0;
  royaltyPercentage;
  royaltyAmountDue: any;
  lessFeesAlreadyPaid: number;
  netDueOrCreditDue: number;
  totalDeductions: any;

  // Get the current studio name from AuthService
  get currentStudio(): string {
    return this._authService.selectedStudio?.name ||
           this._authService.selectedStudio?.key ||
           'Unknown Studio';
  }

  getWeekRangeStart(): string {
    return this.reportDateService.formatDate(
      moment().year(+this.year).isoWeek(+this.week).startOf('isoWeek').format('YYYY-MM-DD')
    );
  }

  getWeekRangeEnd(): string {
    return this.reportDateService.formatDate(
      moment().year(+this.year).isoWeek(+this.week).endOf('isoWeek').format('YYYY-MM-DD')
    );
  }

  /**
   * The reporting period shown on the header table and print-out. Week/year is
   * never what gets reported (line items carry their own receipt-date week);
   * in event mode the period is the event's dates, in legacy mode the
   * selected week's range is kept for continuity.
   */
  getReportPeriodStart(): string {
    const event = this.selectedMiscEvent;
    if (this.selectedMiscEventId && event?.dateStart) {
      return this.reportDateService.formatDate(event.dateStart);
    }
    return this.getWeekRangeStart();
  }

  getReportPeriodEnd(): string {
    const event = this.selectedMiscEvent;
    if (this.selectedMiscEventId && event?.dateEnd) {
      return this.reportDateService.formatDate(event.dateEnd);
    }
    return this.getWeekRangeEnd();
  }

  /**
   * Send/Update gating. Legacy mode: the selected week must have ended (its
   * deductions and receipts are complete). Event mode: the week is irrelevant
   * to this report - the event must have ended instead.
   */
  computeSendDisabled(): boolean {
    if (this.selectedMiscEventId) {
      const dateEnd = this.selectedMiscEvent?.dateEnd;
      // No end date should not happen (the field is required); stay closed.
      if (!dateEnd) { return true; }
      return !moment(dateEnd, 'YYYY-MM-DD').endOf('day').isBefore(moment());
    }
    const weekEnd = moment().isoWeekYear(+this.year).isoWeek(+this.week).endOf('isoWeek');
    return !weekEnd.isBefore(moment());
  }

  /**
   * The week selector's future-week gating only applies in legacy mode; in
   * event mode the gate follows the event's end date instead.
   */
  onSelectorDisabledChange(disabled: boolean): void {
    if (!this.selectedMiscEventId) {
      this.isDisabled = disabled;
    }
  }

  override onPrint() {
    // Build structured content for printing
    const periodLine = this.selectedMiscEventId && this.selectedMiscEvent
      ? `${this.selectedMiscEvent.title} &mdash; ${this.getReportPeriodStart()} - ${this.getReportPeriodEnd()}`
      : `Week ${this.week}, ${this.year}`;

    let content = `
      <h2 class="report-title">Miscellaneous Services Report</h2>
      <p class="report-period">${periodLine}</p>
      <p class="report-studio">${this.currentStudio}</p>
    `;

    // Get the main table content (skip the filter panel)
    const tables = document.querySelectorAll('.container-fluid table.mat-table');
    tables.forEach((table: any) => {
      if (table.offsetParent !== null) { // Check if visible
        const clonedTable = table.cloneNode(true) as HTMLElement;
        // Clean up Angular Material artifacts
        clonedTable.querySelectorAll('[mat-sort-header]').forEach((el: HTMLElement) => {
          el.removeAttribute('mat-sort-header');
        });
        content += '<div class="section">' + clonedTable.outerHTML + '</div>';
      }
    });

    // Add deductions section if exists
    const deductionsSection = document.querySelector('.container-fluid h2:last-of-type');
    if (deductionsSection && deductionsSection.textContent?.includes('Deductions')) {
      content += '<h3>Deductions</h3>';
      let nextElement = deductionsSection.nextElementSibling;
      while (nextElement && nextElement.tagName === 'TABLE') {
        const clonedTable = nextElement.cloneNode(true) as HTMLElement;
        content += '<div class="section">' + clonedTable.outerHTML + '</div>';
        nextElement = nextElement.nextElementSibling;
      }
    }

    // Add totals section
    if (this.totalPaymentsMadeMiscReport !== undefined) {
      content += `
        <div class="totals-section">
          <h3>Report Totals</h3>
          <table class="totals-table">
            <tr>
              <td>Total Payments Made:</td>
              <td class="amount">${this.currencyService.format(this.totalPaymentsMadeMiscReport)}</td>
            </tr>
            <tr>
              <td>Total Charges Due:</td>
              <td class="amount">${this.currencyService.format(this.totalChargesDueMiscReport)}</td>
            </tr>
            <tr>
              <td>Transportation Charges:</td>
              <td class="amount">${this.currencyService.format(this.totalTransportationCharges)}</td>
            </tr>
            <tr>
              <td>Event Expenses:</td>
              <td class="amount">${this.currencyService.format(this.totalEventExpenses)}</td>
            </tr>
            <tr>
              <td>Total Subject to Percentage:</td>
              <td class="amount">${this.currencyService.format(this.totalSubjectToPercentage)}</td>
            </tr>
            <tr>
              <td>Royalty Amount Due (${this.royaltyPercentage}%):</td>
              <td class="amount">${this.currencyService.format(this.royaltyAmountDue)}</td>
            </tr>
            <tr>
              <td>Net Due:</td>
              <td class="amount">${this.currencyService.format(this.netDueOrCreditDue)}</td>
            </tr>
          </table>
        </div>
      `;
    }

    const styles = `
      /* Layout and page setup */
      @media print {
        @page {
          size: portrait;
          margin: 0.4in;
        }
        body {
          zoom: 1;
          transform: scale(1);
          transform-origin: top left;
          width: 100%;
          padding: 0 !important; /* Override print service padding */
        }
      }

      .report-title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
      }

      .report-period {
        font-size: 14px;
        text-align: center;
        margin-bottom: 5px;
      }

      .report-studio {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 15px;
      }

      .section {
        margin-bottom: 15px;
      }

      h3 {
        font-size: 14px;
        font-weight: bold;
        margin: 10px 0 5px 0;
        border-bottom: 1px solid #999;
        padding-bottom: 3px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 10px;
        font-size: 9px;
      }

      th, td {
        padding: 4px 6px;
        border: 1px solid #ccc;
        text-align: left;
      }

      th {
        background-color: #f0f0f0;
        font-weight: bold;
      }

      td.amount {
        text-align: right;
      }

      .totals-section {
        margin-top: 20px;
        border-top: 2px solid #333;
        padding-top: 10px;
      }

      .totals-table {
        width: 60%;
        margin: 0;
      }

      .totals-table td {
        padding: 3px 8px;
      }

      .totals-table tr:last-child {
        font-weight: bold;
        border-top: 2px solid #333;
      }

      /* Hide non-essential elements */
      @media print {
        .mat-expansion-panel,
        .mat-paginator,
        .filter-section,
        .no-print,
        button {
          display: none !important;
        }
      }

      /* Clean up Material classes */
      .mat-header-cell {
        font-weight: bold;
        background-color: #f0f0f0;
      }

      /* Hide Angular Material artifacts */
      .mat-sort-header-container,
      .mat-sort-header-arrow {
        display: none !important;
      }
    `;

    this._printService.print(content, {
      title: this.selectedMiscEventId && this.selectedMiscEvent
        ? `Miscellaneous Services Report - ${this.selectedMiscEvent.title}`
        : `Miscellaneous Services Report - Week ${this.week}, ${this.year}`,
      styles: styles,
      promptPrint: true
    });
  }

  // Get tooltip message for disabled send/update buttons
  get disabledButtonTooltip(): string {
    if (!this.isDisabled) {
      return '';
    }

    if (this.selectedMiscEventId) {
      const dateEnd = this.selectedMiscEvent?.dateEnd;
      return dateEnd
        ? `Ready after the event ends (${moment(dateEnd, 'YYYY-MM-DD').format('MMM D, YYYY')})`
        : 'Ready after the event ends';
    }

    if (this.week && this.year) {
      let selectedDate = moment().isoWeekYear(+this.year).isoWeek(+this.week);
      let weekEnd = selectedDate.clone().endOf('isoWeek').startOf('day').add(1, 'day'); // Monday after the week ends
      let now = moment();

      // Calculate days until Monday (when report is actually available)
      let daysUntilReady = Math.ceil(weekEnd.diff(now, 'days', true));

      if (daysUntilReady < 0) {
        return ''; // Should not happen if isDisabled logic is correct
      } else if (daysUntilReady === 1) {
        return 'Ready tomorrow';
      } else {
        return `Ready in ${daysUntilReady} days`;
      }
    }

    return 'Ready after the week ends';
  }

  /**
   * Event mode state. When an event is selected the report scopes rows to
   * enrollments whose package references the misc_event (backend query alter),
   * matches deductions by event reference, and prefills the send fields from
   * the entity. With no selection every code path is the legacy week-based one.
   */
  miscEvents: any[] = [];
  selectedMiscEventId: string = '';

  get selectedMiscEvent(): any {
    return this.miscEvents.find(e => e.id === this.selectedMiscEventId);
  }

  /**
   * Why event mode shows nothing: packages linked to the selected event, and
   * unlinked candidates staff can link in one click. Populated only when event
   * mode comes back with zero rows. That's the state that confused users ("all the
   * receipts populate... put in the event, everything disappears") when the
   * package had never been linked to the event.
   */
  eventLinkStatus: { linkedCount: number; candidates: { id: string; title: string }[] } | null = null;
  linkingPackageId: string | null = null;

  /** Decide whether the empty-event-mode notice applies to this result set. */
  refreshEventLinkStatus(rows: any[]): void {
    if (!this.selectedMiscEventId || (rows && rows.length > 0)) {
      this.eventLinkStatus = null;
      return;
    }
    this._entityRESTService.getEntity('packages', 'package', 'null')
      .subscribe((data: any) => {
        this.eventLinkStatus = this.computeEventLinkStatus(data ?? []);
      });
  }

  /**
   * Classify the studio's catalog packages against the selected event.
   * Candidates are live misc packages carrying the event's code with no event
   * link yet, the ones staff almost certainly meant to link.
   */
  computeEventLinkStatus(packages: any[]): { linkedCount: number; candidates: { id: string; title: string }[] } {
    const eventId = this.selectedMiscEventId;
    const eventCode = this.selectedMiscEvent?.packageCode;
    let linkedCount = 0;
    const candidates: { id: string; title: string }[] = [];

    for (const pkg of packages) {
      const linkedEventId = pkg?.field_misc_event?.[0]?.target_id?.toString();
      if (linkedEventId === eventId) {
        linkedCount++;
        continue;
      }
      const isMisc = pkg?.field_sps_code?.[0]?.target_id?.toString() === '554';
      const isRetired = pkg?.field_retired?.[0]?.value === true || pkg?.field_retired?.[0]?.value === '1';
      const code = pkg?.field_package_code?.[0]?.target_id?.toString();
      if (!linkedEventId && isMisc && !isRetired && eventCode && code === eventCode) {
        candidates.push({
          id: pkg?.id?.[0]?.value?.toString(),
          title: pkg?.title?.[0]?.value ?? '(untitled package)',
        });
      }
    }

    return { linkedCount, candidates };
  }

  /** One-click repair for the unlinked-package empty state. */
  linkPackageToEvent(pkg: { id: string; title: string }): void {
    if (this.linkingPackageId) { return; }
    this.linkingPackageId = pkg.id;
    this._entityRESTService.patchEntity('packages', 'package', +pkg.id, { field_misc_event: this.selectedMiscEventId })
      .subscribe(
        () => {
          this.linkingPackageId = null;
          // Reload: the linked package's payments appear and the notice clears.
          this.getData(this.queryParams);
        },
        () => { this.linkingPackageId = null; }
      );
  }

  private parseMiscEvents(data: any): any[] {
    return (data ?? []).map((event: any) => ({
      id: event?.id?.toString(),
      title: event?.title ?? '(untitled event)',
      packageCode: event?.package_code?.toString(),
      dateStart: event?.date_start,
      dateEnd: event?.date_end,
      systemWide: !!event?.system_wide,
      // In-use counts from the list endpoint; the manage dialog pre-disables
      // delete on them rather than letting staff discover a 409.
      linkedPackages: Number(event?.linked_packages ?? 0),
      linkedDeductions: Number(event?.linked_deductions ?? 0),
    })).filter((event: any) => event.id);
  }

  /** Franchise-wide events, manageable by super admins only. */
  get franchiseEvents(): any[] {
    return this.miscEvents.filter(event => event.systemWide);
  }

  /** This studio's own events. */
  get studioEvents(): any[] {
    return this.miscEvents.filter(event => !event.systemWide);
  }

  /**
   * Load the events available to this studio: its own plus system-wide ones.
   * The dedicated endpoint exists because the generic ECK list is
   * studio-scoped and cannot see studio-less (franchise) events.
   */
  loadMiscEvents(): void {
    this._drupalRESTService.httpGET('/api/misc-event/list')
      .subscribe((data: any) => {
        this.miscEvents = this.parseMiscEvents(data);
        // A deep link may have set the selection before the list arrived.
        this.prefillFromSelectedEvent();
      });
  }

  /** Selector change: enter/leave event mode and re-run through the merge point. */
  onMiscEventChange(eventId: string): void {
    this.selectedMiscEventId = eventId || '';
    if (this.selectedMiscEventId && this.form?.form) {
      // The event reference is the scope now; a leftover payment date range
      // would silently truncate the rows and the send. The field is hidden in
      // event mode, so clear it rather than letting a stale value linger.
      this.form.form.patchValue({
        field_date_and_time_value_start: null,
        field_date_and_time_value_end: null,
      }, { emitEvent: false });
    }
    this.prefillFromSelectedEvent();
    this.isDisabled = this.computeSendDisabled();
    this.applyFilters();
  }

  /**
   * Copy the event's package code and dates into the send-flow form controls,
   * replacing what staff previously re-typed on every send. Only runs in event
   * mode; legacy mode leaves the controls alone.
   */
  private prefillFromSelectedEvent(): void {
    const event = this.selectedMiscEvent;
    if (!event || !this.form?.form) { return; }

    const patch: any = {};
    if (event.packageCode && this.form.form.controls['field_package_code']) {
      patch.field_package_code = event.packageCode;
    }
    // The date pickers run on MomentDateAdapter: patch moments so the value
    // survives buildRouteParams' moment check on the next navigation.
    if (event.dateStart && this.form.form.controls['event_date_and_time_value_start']) {
      patch.event_date_and_time_value_start = moment(event.dateStart, 'YYYY-MM-DD');
    }
    if (event.dateEnd && this.form.form.controls['event_date_and_time_value_end']) {
      patch.event_date_and_time_value_end = moment(event.dateEnd, 'YYYY-MM-DD');
    }
    if (Object.keys(patch).length) {
      this.form.form.patchValue(patch, { emitEvent: false });
    }
  }

  /**
   * Event management lives in its own dialog: an event is a mode/scope, not a
   * filter, and the create/edit/delete chrome no longer belongs in the filter
   * row. On close, re-read the list so the selector and prefills stay accurate.
   */
  openManageEventsDialog(): void {
    this._dialogService.openDialog(FrmManageMiscEventsComponent, "defaultLargeWithData", {
      // Seed a new event with the package code the report is filtered to, the
      // default the create form has always carried.
      data: { field_package_code: this.form?.form?.value?.field_package_code },
    }).afterClosed().subscribe(result => {
      if (!result?.['changed']) { return; }

      const selectedId = this.selectedMiscEventId;
      this._drupalRESTService.httpGET('/api/misc-event/list')
        .subscribe((data: any) => {
          this.miscEvents = this.parseMiscEvents(data);
          // A deleted selection leaves nothing to scope by: fall back to the
          // week report. Otherwise re-run so the prefills pick up new dates.
          const stillExists = this.miscEvents.some(event => event.id === selectedId);
          this.onMiscEventChange(stillExists ? selectedId : '');
        });
    });
  }

  onYearChange(event: any) {
    this.year = event.value;
    LoggerService.log('year', this.year)
    this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));
  }

  onWeekYearChange(event: WeekYearChangeEvent): void {
    this.week = event.week;
    this.year = event.year;

    // Push week/year through the same route-param merge the other filters use,
    // so the remaining filter values are preserved instead of being replaced.
    this.applyFilters();
  }

  /**
   * Single merge point for every filter on this report.
   *
   * The week/year selector and the in-form filters (package code, payment date
   * range, event date range) both need to end up in one set of query params.
   * Previously week/year called getData() directly with only two params, and
   * getData() replaces this.queryParams wholesale, which dropped whatever the
   * form filters had set. Routing both through updateRouterParams() mirrors the
   * established reports: the URL becomes the single source of truth and the
   * queryParams subscription in ngAfterContentInit reloads the data.
   */
  applyFilters(): void {
    this.updateRouterParams(this.buildRouteParams());
  }

  /**
   * Collect week/year plus every form filter into a route-param object.
   *
   * updateRouterParams() navigates with queryParamsHandling: 'merge', where an
   * omitted key keeps its old value and only an explicit `undefined` removes
   * it. So a cleared filter must be emitted as undefined, not left out, or it
   * would stick in the URL forever.
   */
  private buildRouteParams(): { [key: string]: string } {
    const routeParams: { [key: string]: string } = {
      week: this.week,
      year: this.year,
      // Present-as-undefined when unset so the router merge clears it.
      misc_event: this.selectedMiscEventId || undefined,
    };

    const formValue = this.form?.form?.value ?? {};
    for (const property of MISC_REPORT_FILTER_FIELDS) {
      let value = formValue[property];

      // Date pickers hand back moments (or Dates when patched
      // programmatically); Drupal and the URL expect YYYY-MM-DD.
      if (moment.isMoment(value) || value instanceof Date) {
        value = moment(value).format('YYYY-MM-DD');
      }

      routeParams[property] =
        (value === undefined || value === null || value === '') ? undefined : value;
    }

    return routeParams;
  }

  override ngOnInit(): void {
    this.loadMiscEvents();

    // Pull royalty percentage configuration.
    this._fieldsService.getRoyaltyPercentageConfig().subscribe(royaltyData => {
      LoggerService.log('royalty percentage data', royaltyData);

      // Set the royalty percentage based on the current date and the fetched data
      this.setRoyaltyPercentageBasedOnDate(royaltyData);
    });
  }

  validateAndOpenDialog(operation: string) {
    // Check if form is valid
    if (!this.form || !this.form.valid) {
      // Mark all fields as touched to show validation errors
      if (this.form && this.form.form) {
        Object.keys(this.form.form.controls).forEach(key => {
          const control = this.form.form.controls[key];
          control.markAsTouched();
        });
      }

      // Show error message
      this._snackBar.open('Please fill in all required fields (Package Code and Event dates)', 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    // If form is valid, open the dialog
    this.openDialog(SendUpdateAPIComponent, null, {
      endpoint: 'sendMiscellaneousServiceReportToApi',
      operation: operation,
      // misc_event scopes the server-side send to the event's packages, the
      // same way the on-screen rows are scoped (views query alter).
      form: { ...this.form.form.value, week: this.week, year: this.year, misc_event: this.selectedMiscEventId || null }
    });
  }


  loadMiscServiceDeductions() {
    this._entityRESTService.getEntity('deductions', 'miscservicededuction', 'null')
    .subscribe(data => {
      let deductions = data as any;

      // Get current studio ID for filtering
      const currentStudioId = this._authService.selectedStudio?.id?.toString();

      this.miscServiceDeductions = deductions?.filter((object: any) => {
        // CRITICAL: Filter by studio reference to prevent showing deductions from other studios
        let isCurrentStudio = true;
        if (currentStudioId && object.field_studio_reference) {
          // Check both target_id (reference field) and value formats
          const deductionStudioId = object.field_studio_reference?.[0]?.['target_id'] ||
                                    object.field_studio_reference?.[0]?.['value'];
          isCurrentStudio = (deductionStudioId?.toString() === currentStudioId);
        }
        if (!isCurrentStudio) { return false; }

        const deductionEventId = object.field_misc_event?.[0]?.['target_id']?.toString();

        // Event mode: only deductions referencing the selected event, whatever
        // week they were entered in.
        if (this.selectedMiscEventId) {
          return deductionEventId === this.selectedMiscEventId;
        }

        // Legacy mode: match by week/year as before, and exclude event-linked
        // deductions. Those belong to their event's report, and showing them
        // here too would double-count the week they happen to be stamped with.
        if (deductionEventId) { return false; }
        let isThisReportWeekYear = (object.field_week_report_number?.[0]?.['value'] == this.week);
        let isThisReportYear = (object.field_year_report_number?.[0]?.['value'] == this.year);
        return (isThisReportWeekYear && isThisReportYear);
      });

      this.calcDeductionTotals(this.miscServiceDeductions);
    })
  }

calcTotals(miscReportData: any) {
  this.totalPaymentsMadeMiscReport = 0;
  this.totalChargesDueMiscReport = 0;

  const processedPackageIds = new Set();

  miscReportData.forEach(data => {
    const packageId = data?.package_id;

    // Skip over any duplicate package_id
    if (packageId && processedPackageIds.has(packageId)) {
      return;
    }

    // Mark this package_id as processed
    if (packageId) {
      processedPackageIds.add(packageId);
    }

    // Total Payments Made
    this.totalPaymentsMadeMiscReport += +data?.field_total_payments_made;
    // Total Charges Due
    // this.totalChargesDueMiscReport += (+data?.field_enrollment_total_price - +data?.field_total_payments_made);
    this.totalChargesDueMiscReport += +data?.field_enrollment_total_price;
  });
}

  calcDeductionTotals(miscServiceDeductions: any) {
    this.totalTransportationCharges = 0;
    this.totalEventExpenses = 0;
    this.totalSubjectToPercentage = 0;
    this.additionalAmountDue = 0;

    miscServiceDeductions?.forEach(deduction => {
      LoggerService.log('deduction', deduction)
      this.totalTransportationCharges += deduction.field_transportation_cost?.[0]?.value;
      this.totalEventExpenses += deduction.field_event_expenses?.[0]?.value;
      this.additionalAmountDue += deduction.field_transportation_cost?.[0]?.value;
    });

    this.totalDeductions = this.totalEventExpenses + this.totalTransportationCharges

    // totalPaymentsMadeMiscReport - this.totalTransportationCharges - this.totalEventExpenses

    this.totalSubjectToPercentage = this.totalPaymentsMadeMiscReport - this.totalTransportationCharges - this.totalEventExpenses;
    this.royaltyAmountDue = this.totalSubjectToPercentage * (this.royaltyPercentage / 100);
    this.lessFeesAlreadyPaid = this.totalPaymentsMadeMiscReport * (this.royaltyPercentage / 100);
    this.netDueOrCreditDue = this.royaltyAmountDue - this.lessFeesAlreadyPaid;
  }

  override ngAfterContentInit(): void {
    this._activatedRoute.queryParams.subscribe(data => {
      LoggerService.log('subscribed data', data)
      this.ShowProgressBar = false;

      if (data['year']) {
        this.year = data['year']
      } else {
        this.year = this._fieldsService.getCorrectYearForWeek(new Date()).toString();
      }
      if (data['week']) {
        this.week = data['week']
      } else {
        this.week = this._fieldsService.getCurrentWeek().toString();
      }

      // Update weeks dropdown data to match the year
      this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));

      let getData = [
        { parameter: 'week', value: this.week},
        { parameter: 'year', value: this.year},
      ];

      // Rehydrate the remaining filters from the URL, which is the source of
      // truth once a filter has been applied. Reading them back off the form
      // missed the event date range entirely and went stale whenever a filter
      // change and the resulting navigation raced.
      for (const property of MISC_REPORT_FILTER_FIELDS) {
        if (data[property]) {
          getData.push({ parameter: property, value: data[property] });
        }
      }

      // Event mode rides the URL like every other filter.
      this.selectedMiscEventId = data['misc_event'] || '';
      if (this.selectedMiscEventId) {
        getData.push({ parameter: 'misc_event', value: this.selectedMiscEventId });
        this.prefillFromSelectedEvent();
      }

      this.getData(getData);

      // Keep the filter panel showing what's actually applied.
      this.restoreFilterControls(data);
    })
  }

  /**
   * Mirror the URL's filter values back into the form controls.
   *
   * Without this the panel renders blank after a week change even though the
   * filters are still applied to the query, and the required-field validators
   * would block the Send/Update buttons on a legitimately filtered report.
   */
  private restoreFilterControls(params: { [key: string]: any }): void {
    // Controls only exist once the expansion panel's form has rendered.
    if (!this.form?.form) { return; }

    const patch: { [key: string]: any } = {};
    for (const property of MISC_REPORT_FILTER_FIELDS) {
      if (!this.form.form.controls[property]) { continue; }

      const value = params[property];
      if (value === undefined || value === '') { continue; }

      // Date controls are bound to MomentDateAdapter pickers; the URL carries
      // YYYY-MM-DD. Skip anything that does not parse rather than blanking
      // the control with an invalid date.
      if (property.includes('date_and_time')) {
        const parsed = moment(value, 'YYYY-MM-DD', true);
        if (!parsed.isValid()) { continue; }
        patch[property] = parsed;
      } else {
        patch[property] = value;
      }
    }

    if (Object.keys(patch).length) {
      // emitEvent: false. Patching is a reflection of state already applied,
      // not a new filter change, so it must not re-trigger applyFilters().
      this.form.form.patchValue(patch, { emitEvent: false });
    }
  }

  /**
   * Clear the filter controls but keep the report anchored to its week/year.
   *
   * The base implementation wipes every query param, which would strip week and
   * year from the URL and leave this report with no reporting period.
   */
  override resetForm() {
    this.sortParams = undefined;

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.form?.resetForm();

    // Re-apply with the form cleared: week/year survive, filters drop out.
    this.applyFilters();
  }

  override clearFormTableData() {
    // Call parent implementation
    super.clearFormTableData();

    // Reset all miscellaneous report specific values to prevent carryover from previous reports
    this.eventLinkStatus = null;
    this.miscServiceDeductions = null;
    this.totalPaymentsMadeMiscReport = 0;
    this.totalChargesDueMiscReport = 0;
    this.totalTransportationCharges = 0;
    this.totalEventExpenses = 0;
    this.totalSubjectToPercentage = 0;
    this.additionalAmountDue = 0;
    this.royaltyAmountDue = 0;
    this.lessFeesAlreadyPaid = 0;
    this.netDueOrCreditDue = 0;
    this.totalDeductions = 0;
  }

  override getData(params: { parameter: string; value: string; }[]) {
    this.isDisabled = this.computeSendDisabled();

    this.clearFormTableData();

    // let filters = '?';
    // if (params) {
    //   for (const property in params) {
    //     // LoggerService.log(params[property])
    //     if (params[property]?.['parameter'] == 'Active') {
    //       // filters = filters + "status[]=active&";
    //       filters = filters + "&field_last_lesson_date=" + moment().subtract(30, 'days').format('YYYY-MM-DD') + "--";
    //     }
    //     if (params[property]?.['parameter'] == 'Inactive') {
    //       filters = filters + "&field_last_lesson_date=" + "--" + moment().subtract(30, 'days').format('YYYY-MM-DD');
    //     }
    //   }
    // }

    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;
    this.queryParams = params;

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    // Load the new student list with the filtering parameters.
    this._drupalRESTService.httpGET('/api_rest/v1/miscellaneous-services-report', this.queryParams)
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;
        LoggerService.log(data['results']);

        let rows = data['results'];

        // No rows? Don't continue...
        if (!rows) { return; }

        this.data = data;
        this.dataSource = new MatTableDataSource(rows);

        this.loadMiscServiceDeductions();
        this.calcTotals(data['results']);
        this.refreshEventLinkStatus(rows);

        // Pagination
        if (data['results']) {
          this.setupPagination(data, params);
        }
      },
        error => this.handleError(error)
      )
  }

  calcRoyaltyPercentage(amount) {
    amount = this._filterDigits(amount+'');
    return (amount * (this.royaltyPercentage / 100));
  }

  setRoyaltyPercentageBasedOnDate(data) {
    // Extract start and end dates of the specified week.
    const startDate = moment().year(+this.year).isoWeek(+this.week).startOf('isoWeek').utc().startOf('day').toDate();
    const endDate = moment().year(+this.year).isoWeek(+this.week).endOf('isoWeek').utc().endOf('day').toDate();

    let foundMatchingPeriod = false;
    let lowestPercentage = Infinity;

    // Check if 'royalty_periods' exists and has data.
    if (data.royalty_periods && data.royalty_periods.length > 0) {
      for (const period of data.royalty_periods) {
        // Extract period start and end dates and check if they exist.
        const periodStartDate = moment(period.start_date).utc().startOf('day').toDate();
        const periodEndDate = moment(period.end_date).utc().endOf('day').toDate();

        // If start and end dates exist, check for matching period.
        if (periodStartDate && periodEndDate && startDate >= periodStartDate && endDate <= periodEndDate) {
          const percentage = parseFloat(period.royalty_percentage);
          if (percentage < lowestPercentage) {
            lowestPercentage = percentage;
            this.royaltyPercentage = percentage;
            foundMatchingPeriod = true;
          }
        }
      }
    }
    // If no matching period is found, set the default royalty percentage
    if (!foundMatchingPeriod && data.default_royalty_percentage) {
      LoggerService.log('no matching period found, using default royalty percentage', data.default_royalty_percentage)
      this.royaltyPercentage = parseFloat(data.default_royalty_percentage);
    }
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');

    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }

    // DO NOT call updateRouterParams here - this prevents duplicate requests
    // The routing has already been handled by pageChanged() or other methods
    LoggerService.log('setupPagination called - skipping route update to prevent duplicates');
  }

}
